const types = {
  403: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
    title: '403',
    desc: '抱歉，你无权访问该页面',
    desc71: '哎呀，您好像暂无当前页面权限，建议跟管理员确认，或者请您再检查一下链接地址哦。'
  },
  404: {
    img: window._CONFIG['resourceURL'] + '/school/sys/common/downloadSlice?filename=/common/404.png', //'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
    title: '404',
    desc: '抱歉，你访问的页面不存在或无权访问',
    desc71: '哎呀，您好像暂无当前页面权限，建议跟管理员确认，或者请您再检查一下链接地址哦。'
  },
  500: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
    title: '500',
    desc: '抱歉，服务器出错了',
    desc71: '哎呀，服务器好像正在升级系统，请稍后再试哦。'
  }
}

export default types